<div class="payment-type-container"
     [class.active]="isSelected"
     [class.disabled]="disabled"
     (click)="select()">
  <div class="payment-type-radio">
    <mat-radio-button class="custom-radio-button"
                      [disabled]="disabled"
                      [value]="isSelected"
                      [ngClass]="{'choice-delivery-radio-active': isSelected, 'choice-delivery-radio': !isSelected}"
                      [name]="name" [checked]="isSelected">
    </mat-radio-button>
    <span class="payment-type"> {{ isPaymentTypeSelect ? titleByPaymentType : label }}</span>
  </div>
  @if (isPaymentTypeSelect) {
    <div class="flex-direction-row justify-content-between">
      <img [src]="PaymentTypeUtil.getIconByType(paymentType)" class="payment-type-icon" [alt]="paymentType">
    </div>
  }
</div>

@if (isSelected) {
  @if (isPaymentTypeSelect && !isSelectedTypeCreditCard) {
    <div class="payment-type-dropdown">
      <span class="payment-type-dropdown-text">{{ 'payment.pay_with_redirect_message' | translate:{ paymentType: paymentType } }}</span>
    </div>
  } @else if (useDifferentBillingAddress) {
    <div class="payment-type-dropdown">
      <app-filled-form-field [label]="'Country / Region'" class="width-100" [isSuffixIconVisible]="true" icon="arrow">
      </app-filled-form-field>

      <app-filled-form-field [label]="'Address'" class="width-100">
      </app-filled-form-field>

      <app-filled-form-field [label]="'Apartment, suite, etc.'" [optional]="true" class="width-100">
      </app-filled-form-field>

      <div class="width-100 pt-flex-direction-row justify-content-between">
        <app-filled-form-field [label]="'Postal Code'" class="width-48">
        </app-filled-form-field>
        <app-filled-form-field [label]="'City'" class="width-48">
        </app-filled-form-field>
      </div>
    </div>
  }
}
